'use client';

import React, { useCallback } from 'react';
import { ReportEditor } from '@/components/writing/report-editor';
import { BaseWritingPage } from '@/components/writing/base-writing-page';

export default function WritingTask1Page() {
  const handleScoreReceived = useCallback(() => {}, []);

  return (
    <BaseWritingPage
      taskType='task1'
      title='IELTS Writing Task 1'
      newButtonText='New Report'
      loadButtonText='Load Report'
      sheetTitle='Your Task 1 Reports'
      authRequiredText='Please log in to write and save your Writing Task 1 reports.'
    >
      {({ selectedTask, triggerSuggestionClear, defaultBodyParagraphs }) => (
        <ReportEditor
          key={`${selectedTask?.id || 'new-task1'}`}
          initialPrompt={selectedTask?.prompt || ''}
          initialIntroduction={selectedTask?.introduction || ''}
          initialOverview={selectedTask?.overview || ''}
          initialDetailParagraphs={
            selectedTask?.bodyParagraphs || defaultBodyParagraphs
          }
          initialImageUrl={selectedTask?.imageUrl || ''}
          initialTask1Type={selectedTask?.task1Type}
          initialVisualType={selectedTask?.visualType}
          initialReportPlan={
            selectedTask?.taskType === 'task1'
              ? (
                  selectedTask as {
                    reportPlan?: { label: string; content: string }[];
                  }
                ).reportPlan
              : undefined
          }
          initialEssayId={selectedTask?.id || null}
          onSuggestionSuccess={handleScoreReceived}
          suggestionClearTrigger={triggerSuggestionClear}
        />
      )}
    </BaseWritingPage>
  );
}
